import { Controller, useFormContext } from "react-hook-form";
import { ErrorMessage, Toggle, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddTransferTypeFormData, FIXED_TRIP_TYPES } from "../../form";

export const TransferTypeIsAdminOnlyField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<AddTransferTypeFormData>();

  const tripType = watch("tripType");
  const isFixedType = FIXED_TRIP_TYPES.includes(tripType);

  return (
    <div className={clsx("flex w-full items-center gap-x-1.5", className)} {...props}>
      <div className="flex flex-1 flex-col">
        <Typography variant="paragraph">Admin Only Transfer Type</Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          {isFixedType
            ? "Fixed transfer types are always admin-only. Clients must contact you to book, modify, or cancel a job with this transfer type."
            : "If enabled, only admins can use this transfer type. Clients must contact you to modify or cancel a job with this transfer type."}
        </Typography>
      </div>
      <Controller
        name="isAdminOnly"
        control={control}
        render={({ field }) => (
          <div className="flex items-center gap-4">
            <Toggle
              checked={field.value}
              onChange={(checked) => {
                if (!isFixedType) {
                  field.onChange(checked);
                }
              }}
              disabled={isFixedType}
            />
          </div>
        )}
      />
      <ErrorMessage errors={errors} name="isAdminOnly" />
    </div>
  );
};
